import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Bridal from "@/pages/Bridal";
import Academy from "@/pages/Academy";
import StudentSuccess from "@/pages/StudentSuccess";
import Gallery from "@/pages/Gallery";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";

const Site = ({ children }) => <Layout>{children}</Layout>;

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback before any routing
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Site><Home /></Site>} />
      <Route path="/about" element={<Site><About /></Site>} />
      <Route path="/services" element={<Site><Services /></Site>} />
      <Route path="/bridal" element={<Site><Bridal /></Site>} />
      <Route path="/academy" element={<Site><Academy /></Site>} />
      <Route path="/student-success" element={<Site><StudentSuccess /></Site>} />
      <Route path="/gallery" element={<Site><Gallery /></Site>} />
      <Route path="/testimonials" element={<Site><Testimonials /></Site>} />
      <Route path="/contact" element={<Site><Contact /></Site>} />
      <Route path="/book" element={<Site><Book /></Site>} />
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
